import { Component, OnInit } from '@angular/core';
import { CaseService } from 'src/app/services/case.service';
import { Router, RouterModule } from '@angular/router';
import { ActiveUserService } from '../../services/activeuser.service';
import { DemoCase } from '../../models/DemoCase';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-demos',
  standalone: true,
  imports: [RouterModule, NgbDropdownModule],
  templateUrl: './demos.component.html',
  styleUrl: './demos.component.scss'
})
export class DemosComponent {
  cases: DemoCase[] = [];
  dialogs: string[] = ["gamtest", "mythbuster", "realitycheck", "game-changer", "how-do-i-compare"];

  constructor(private caseService: CaseService, private router: Router, private activeUser: ActiveUserService) { }

  ngOnInit(): void {
    this.getCases();
  }

  getCases(): void {
    try {
      this.caseService.getCases()
        .subscribe(
          cases => {
            for (const key in cases) {
              if (Object.prototype.hasOwnProperty.call(cases, key)) {
                if (typeof (cases[key]) === 'object' && key != 'default') {
                  this.cases.push(cases[key]);
                }
              }
            }
          },
          (e) => {
            console.error("Error 1 in DemosComponent", e);
            this.router.navigate(['/error']);
          });
    } catch (e) {
      console.error("Error 2 in DemosComponent", e);
      this.router.navigate(['/error']);
    }
  }

  navigate(accountId: number | undefined, target: string): void {
    if (accountId === undefined) {
      accountId = 123999;
    }

    if (target === 'dashboard') {
      this.router.navigate(['/dashboard', { jwt: accountId }]);
    }

    if (target === 'messages') {
      this.router.navigate(['/messages', { jwt: accountId }]);
    }

    if (this.dialogs.includes(target)) {
      this.router.navigate(['/dialogs/:dialog', { dialog: target, jwt: accountId }]);
    }
  }
}
